import(/* webpackMode: "eager" */ "/workspace-install/projects/astrolive-app/common/components/404/index.module.scss");
import(/* webpackMode: "eager" */ "/workspace-install/projects/astrolive-app/node_modules/next/dist/client/link.js")